import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import s from './BooleanField.module.scss';
import { useOwned } from './hooks/useOwned';
import { Radio } from 'src/shared/ui/_inputs/Radio';

interface Props extends GeneratedField {
	options?: string[];
}

export const BooleanField: React.FC<Props> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
		validate,
		options,
	} = props;

	// * Form
	const { setValue, getValues, control } = useFormContext();
	const formValues = getValues();

	const name = `${namePrefix}${propertyName}.${internalName}`;

	// * Diversity by Ownership logic
	const { handleOwnedTrue, handleOwnedFalse, disabled } = useOwned(propertyName);

	// * Functions
	const labelExceptions = (value: 'true' | 'false') => {
		if (options) {
			return value === 'true' ? options[1] : options[0];
		}
		return value === 'true' ? 'Yes' : 'No';
	};

	const onChangeTrue = () => {
		setValue(`${name}.value`, 'true');

		handleOwnedTrue(); // Diversity by Ownership
	};

	const onChangeFalse = () => {
		setValue(`${name}.value`, 'false');

		if ('target' in formValues.properties[propertyName]) {
			setValue(`properties.${propertyName}.target.value`, null);
		}

		if ('deadline' in formValues.properties[propertyName]) {
			setValue(`properties.${propertyName}.deadline.value`, null);
		}

		handleOwnedFalse(); // Diversity by Ownership
	};

	// * Render
	return (
		<Controller
			name={`${name}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field }) => (
				<div className={s.fieldWrapper}>
					<div className={s.radioWrapper}>
						<Radio
							{...field}
							label={labelExceptions('true')}
							checked={field.value === 'true'}
							onChange={() => onChangeTrue()}
							disabled={disabled}
						/>

						<Radio
							{...field}
							label={labelExceptions('false')}
							checked={field.value === 'false'}
							onChange={() => onChangeFalse()}
							disabled={disabled}
						/>
					</div>
				</div>
			)}
		/>
	);
};
